import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./Kyc.module.css";
import { useAuth } from "../../components/context/Auth";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import Button from "../../components/updatedComponents/Dealers/Button";
import { KycPls, KycUplodFile, Upload } from "../../components/icons/Icon2";
import { ManagerCameraIcon, } from "../../components/icons/Icon";
import InputTag from "../../components/updatedComponents/FormComponents/InputTag";
import UploadSingleFile from "../../components/updatedComponents/kyc/UploadSingleFile";
import InputRedio from "../../components/updatedComponents/FormComponents/InputRedio";
import VerticalDropDown from "../../components/updatedComponents/FormComponents/VerticalDropDown";
import { useParams } from "react-router-dom";
import fetchData from "../../APIsControll/apiControll";
import ModalWrapper from "../../components/updatedComponents/layoutWrapper/ModalWrapper";
import ImageCroper2 from "./ImageCroper2";
import { handleFileData } from "../../APIsControll/apiControl2";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import { IsEdite } from "../../components/icons/Icon3";
import { Delete1 } from "../../components/icons/Icon4";

const Kyc = () => {
  const { mode, managerId } = useAuth();
  const { show } = useToast();
  const apiKey = process.env.REACT_APP_MAP_KEY;
  const mapApiJs = "https://maps.googleapis.com/maps/api/js";
  const [previewImage, setPreviewImage] = useState(null);

  const [loading, setloading] = useState({
    loading: false,
    locationLoading: false,
  });
  const [loadingDerler, setLoadingDerler] = useState(false);
  const [isEdite, setEdite] = useState(false);
  const [profileFile, setProfileFile] = useState(null);
  const [previewImage1, setPreviewImage1] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [managers, setManagers] = useState([]);
  const [StoreImage, setStoreImage] = useState(null);
  const searchInput = useRef(null);
  const [inputSearch, setInputSearch] = useState("");
  const { id } = useParams();
  const fileInputRef = useRef(null);
  const inputForstore = useRef(null);
  const [address, setAddress] = useState({
    place_id: "",
    formatted_address: "",
  });

  const [genralInfo, setGenralInfo] = useState({
    name: "",
    product: [],
    storeName: "",
    mobile: "",
    email: "",
    pod: true,
    shippingBlock: false,
    designation: "",
    whatsapp: "",
    gstuin: "",
    street: "",
    pincode: "",
    city: "",
    district: "",
    state: "",
    country: "",
    facebook: "",
    instagram: "",
    youtube: "",
    pinterest: "",
    twitter: "",
    storeDesc: "",
    experience: "",
    google: "",
    nrne: "",
    catalogStatus: "",
    profileImage: "",
    storeImg: "",
    leadBlock: "",
    status: "",
    managerId: "",
    podReason: "",
  });

  const handlePhotoUploadClick = () => {
    fileInputRef.current.click();
  };
  const handlePhotoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // setPreviewImage1(true)
      setProfileFile(file);
      const imageUrl = URL.createObjectURL(file);
      setPreviewImage(imageUrl);
    }
  };
  const handlePhotoUploadClick1 = () => {
    inputForstore.current.click();
  };
  const handleChangeForStoreImage = (event) => {
    const file = event.target.files[0];
    if (file) {
      // const imageUrl = URL.createObjectURL(file);
      // console.log("imageUrl", imageUrl);
      // console.log("file", file);

      setStoreImage(file);
    }
  };

  function loadAsyncScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      Object.assign(script, {
        type: "text/javascript",
        async: true,
        src,
      });
      script.addEventListener("load", () => resolve(script));
      document.head.appendChild(script);
    });
  }

  // init gmap script
  const initMapScript = () => {
    // if script already loaded
    if (window.google) {
      return Promise.resolve();
    }
    const src = `${mapApiJs}?key=${apiKey}&libraries=places&v=weekly`;
    return loadAsyncScript(src);
  };

  // do something on address change
  const onChangeAddress = (autocomplete) => {
    const place = autocomplete.getPlace();
    setAddress((prevState) => ({
      ...prevState,
      place_id: place?.place_id,
      formatted_address: place?.formatted_address,
    }));
  };

  // init autocomplete
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const initAutocomplete = () => {
    if (!searchInput.current) return;
    const autocomplete = new window.google.maps.places.Autocomplete(
      searchInput.current,
      { componentRestrictions: { country: "in" } }
    );
    // //console.log("autocomplete", autocomplete);

    autocomplete.setFields([
      "address_components",
      "formatted_address",
      "place_id",
      "geometry",
      "name",
    ]);
    autocomplete.addListener("place_changed", () =>
      onChangeAddress(autocomplete)
    );
  };

  // load map script after mounted
  useEffect(() => {
    if (inputSearch) {
      initMapScript().then(() => initAutocomplete());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputSearch, initAutocomplete]);

  useEffect(() => {
    if (address.formatted_address) {
      setInputSearch(address?.formatted_address);
    }
  }, [address?.formatted_address]);
  // //console.log(genralInfo);

  const getDealerInfo = async () => {
    try {
      setLoadingDerler(true);
      const payload = {
        managerId: managerId,
        dealerId: id,
      };
      const result = await fetchData(`kyc/dealer`, payload);
      setGenralInfo((prevState) => ({
        ...prevState,
        name: result.data.name ? result.data.name : "",
        profileImage: result.data.profileImage ? result.data.profileImage : "",
        storeImg: result.data.storeImg ? result.data.storeImg : "",
        storeName: result.data.storeName ? result.data.storeName : "",
        mobile: result.data.mobile ? result.data.mobile : "",
        email: result.data.email ? result.data.email : "",
        pod: result.data.pod === undefined ? true : result.data.pod,
        shippingBlock: result.data.shippingBlock === undefined ? false : result.data.shippingBlock,
        designation: result.data.designation ? result.data.designation : "",
        whatsapp: result.data.whatsapp ? result.data.whatsapp : "",
        gstuin: result.data.gstuin ? result.data.gstuin : "",
        street: result.data.street ? result.data.street : "",
        pincode: result.data.pincode ? result.data.pincode : "",
        city: result.data.city ? result.data.city : "",
        district: result.data.district ? result.data.district : "",
        state: result.data.state ? result.data.state : "",
        country: result.data.country ? result.data.country : "",
        facebook: result.data.facebook ? result.data.facebook : "",
        instagram: result.data.instagram ? result.data.instagram : "",
        youtube: result.data.youtube ? result.data.youtube : "",
        pinterest: result.data.pinterest ? result.data.pinterest : "",
        twitter: result.data.twitter ? result.data.twitter : "",
        storeDesc: result.data.storeDesc ? result.data.storeDesc : "",
        experience: result.data.experience ? result.data.experience : "",
        google: result.data.google ? result.data.google : "",
        nrne: result.data.nrne ? result.data.nrne : "",
        podReason: result.data.podReason ? result.data.podReason : "",
        catalogStatus: result.data.catalogStatus
          ? result.data.catalogStatus
          : "",
        leadBlock: result.data.leadBlock ? result.data.leadBlock : false,
        managerId: result.data.managerId ? result.data.managerId : "",
        status: result.data.status ? result.data.status : "",
        product: result.products ? result.products : "",
      }));
      setAddress((prevState) => ({
        ...prevState,
        place_id: result.data?.place_id ? result.data?.place_id : "",
        formatted_address: result.data?.formatted_address
          ? result.data?.formatted_address
          : "",
      }));
      setPreviewImage(
        result.data.profileImage === ""
          ? null
          : `${process.env.REACT_APP_S3URL}${result.data.profileImage}`
      );
      setProfileFile(result.data.profileImage);
      setStoreImage(
        result.data.storeImg === ""
          ? ""
          : `${process.env.REACT_APP_S3URL}${result.data.storeImg}`
      );

      if (result.products) {
        setAllProducts(result.products);
        setSelectedProducts(result.data.selectedProducts);
      }
      if (result.managers) {
        setManagers(result.managers);
      }
    } catch (error) {
      //console.log("error ", error);
    } finally {
      setLoadingDerler(false)
    }
  };
  useEffect(() => {
    setEdite(false);
    getDealerInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateKyc = useCallback(async () => {
    // if (!profileFile || profileFile === "") {
    //   show("Profile image is required", "error");
    //   return;
    // }
    try {
      setloading({ ...loading, loading: true });
      const formData = new FormData();
      formData.append("name", genralInfo.name);
      formData.append("designation", genralInfo.designation);
      formData.append("storeName", genralInfo.storeName);
      formData.append("street", genralInfo.street);
      formData.append("pincode", genralInfo.pincode);
      formData.append("city", genralInfo.city);
      formData.append("pod", genralInfo.pod);
      formData.append("shippingBlock", genralInfo.shippingBlock);
      formData.append("podReason", genralInfo.podReason);
      formData.append("district", genralInfo.district);
      formData.append("state", genralInfo.state);
      formData.append("country", genralInfo.country);
      formData.append("phone", genralInfo.mobile);
      formData.append("whatsapp", genralInfo.whatsapp);
      formData.append("email", genralInfo.email);
      formData.append("gstuin", genralInfo.gstuin);
      formData.append("place_id", address.place_id);
      formData.append("formatted_address", address.formatted_address);
      formData.append("assignedManager", genralInfo.managerId);
      formData.append("nrne", genralInfo.nrne);
      formData.append("catalogStatus", genralInfo.catalogStatus);
      formData.append("leadBlock", genralInfo.leadBlock); /// no ideia
      formData.append("status", genralInfo.status); // NO ideia
      formData.append("experience", genralInfo.experience);
      formData.append("selectedProducts", JSON.stringify(selectedProducts));
      formData.append("storeDesc", genralInfo.storeDesc);
      formData.append("facebook", genralInfo.facebook);
      formData.append("twitter", genralInfo.twitter);
      formData.append("instagram", genralInfo.instagram);
      formData.append("youtube", genralInfo.youtube);
      formData.append("pinterest", genralInfo.pinterest);
      formData.append("profileImage", profileFile);
      formData.append("storeImg", StoreImage);
      formData.append("rejectionList", JSON.stringify({}));

      const res = await handleFileData(
        `kyc/dealerKyc?managerId=${managerId}&dealerId=${id}`,
        formData
      );
      // //console.log("kyc res = " + res);
      if (res.status === "success") {
        show(res.msg, "success");
        return;
      }
      if (res.status === "failed") {
        show(res.msg, "error");
        return;
      }
    } catch (error) {
      show(error.message, "error");
    } finally {
      setloading({ ...loading, loading: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [genralInfo, id, managerId, profileFile, selectedProducts, address, StoreImage]);

  const handelEdit = () => {
    //console.log("done");
    setEdite(!isEdite);
  };

  const getLocation = async () => {
    try {
      setloading({ ...loading, locationLoading: true });
      const payload = {
        keyword: genralInfo.pincode,
      }
      const res = await fetchData(`locations/locations`, payload);
      if (res.status === "success") {
        setGenralInfo(prevState => ({
          ...prevState,
          city: res.SubDistName[0] ? res.SubDistName[0].toUpperCase() : "",
          district: res.districts[0] ? res.districts[0] : "",
          state: res.states[0] ? res.states[0] : "",
        }))
      }

    } catch (error) {
      console.log(error);
    }
    finally {
      setloading({ ...loading, locationLoading: false });
    }
  }

  useEffect(() => {
    // Make sure pincode exists and is a 6-digit number
    if (genralInfo.pincode && genralInfo.pincode.length === 6) {
      getLocation();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [genralInfo.pincode]);



  // console.log("StoreImage:", typeof StoreImage)


  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        updateKyc();
      }}
    >
      <div className={styles.main}>
        <div
          className={styles.continer}
          style={{ backgroundColor: mode ? "#2C2E33" : "#F8F9FC" }}
        >
          <ModalWrapper isOpen={previewImage1}>
            <ImageCroper2 image={previewImage} />
          </ModalWrapper>
          {/* top bar for go back */}
          <div className={styles.go_back}>
            <div>
              <TopTabBar text={"Dealer"} />
            </div>
            <div>
              <div style={{ width: "120px" }}>
                {isEdite ? (
                  <Button
                    buttonBgColor={"#4164E3"}
                    buttonText={"Update"}
                    buttonTextColor={"#fff"}
                    buttonIcon={<Upload />}
                    loading={loading.loading}
                    disabled={loading.loading}
                  />
                ) : (
                  <Button
                    buttonBgColor={"#4164E3"}
                    buttonText={"Edit"}
                    buttonTextColor={"#fff"}
                    buttonIcon={<IsEdite />}
                    loading={loading.loading}
                    disabled={loading.loading}
                    buttonClick={(e) => {
                      e.preventDefault();
                      handelEdit();
                    }}
                  />
                )}
              </div>
            </div>
          </div>

          <div className={styles.Personal_Info}>
            <div
              className={styles.Personal}
              style={{
                backgroundColor: mode ? "#232529" : "#fff",
                color: mode ? "#fff" : "#000",
              }}
            >
              <div className={styles.profileContainer}>
                <p>Personal Info</p>
                <div
                  className={styles.nm_photo}
                  onClick={handlePhotoUploadClick}
                  style={{ border: mode ? "1px solid #000" : "1px solid #ccc" }}
                >
                  {
                    previewImage || genralInfo.profileImage ?
                      <img
                        src={previewImage || `${process.env.REACT_APP_S3URL}${genralInfo?.profileImage}`}
                        alt="Manager" /> :
                      <div className={styles.Frist_text}>
                        {genralInfo.name.charAt(0).toUpperCase()}
                      </div>
                  }
                  <div className={styles.nm_camera_icon}>
                    <ManagerCameraIcon />
                  </div>
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handlePhotoChange}
                    accept="image/*"
                    disabled={isEdite ? false : true}
                  />
                </div>
                <div className={styles.nm_info}>
                  <InputTag
                    labelText={"Full Name"}
                    star={true}
                    padding={"8px"}
                    fontSize={"12px"}
                    placeholderText={"Enter Full Name"}
                    maxLength={100}
                    placeholderType={"text"}
                    value={genralInfo?.name}
                    onChange={(event) => {
                      setGenralInfo({
                        ...genralInfo,
                        name: event.target.value,
                      });
                    }}
                    required={true}
                    disabled={isEdite ? false : true}
                    loading={loadingDerler}
                  />
                </div>
                <div className={styles.nm_info}>
                  <InputTag
                    labelText={"Mobile Number"}
                    star={true}
                    padding={"8px"}
                    fontSize={"12px"}
                    placeholderText={"Enter Mobile Number"}
                    maxLength={10}
                    placeholderType={"number"}
                    value={genralInfo?.mobile}
                    onChange={(event) => {
                      setGenralInfo({
                        ...genralInfo,
                        mobile: event.target.value,
                      });
                    }}
                    required={true}
                    disabled={true}
                    loading={loadingDerler}
                  />
                </div>
                <div className={styles.nm_info}>
                  <InputTag
                    labelText={"Designation"}
                    star={true}
                    padding={"8px"}
                    fontSize={"12px"}
                    placeholderText={"Enter Designation"}
                    maxLength={100}
                    placeholderType={"text"}
                    value={genralInfo?.designation}
                    onChange={(event) => {
                      setGenralInfo({
                        ...genralInfo,
                        designation: event.target.value,
                      });
                    }}
                    required={true}
                    disabled={isEdite ? false : true}
                    loading={loadingDerler}
                  />
                </div>
              </div>
            </div>
            <div
              className={styles.Company}
              style={{
                backgroundColor: mode ? "#232529" : "#fff",
                color: mode ? "#fff" : "#000",
              }}
            >
              <div className={styles.Company_FristChile}>
                <div className={styles.nm_info}>
                  <InputTag
                    labelText={"Company Name"}
                    star={true}
                    padding={"8px"}
                    fontSize={"12px"}
                    placeholderText={"Enter Company Name"}
                    maxLength={100}
                    placeholderType={"text"}
                    value={genralInfo?.storeName}
                    onChange={(event) => {
                      setGenralInfo({
                        ...genralInfo,
                        storeName: event.target.value,
                      });
                    }}
                    required={true}
                    disabled={isEdite ? false : true}
                    loading={loadingDerler}
                  />
                </div>
                <div className={styles.nm_info}>
                  <InputTag
                    labelText={"Email"}
                    star={true}
                    padding={"8px"}
                    fontSize={"12px"}
                    placeholderText={"Enter Email"}
                    maxLength={50}
                    placeholderType={"email"}
                    value={genralInfo?.email}
                    onChange={(event) => {
                      setGenralInfo({
                        ...genralInfo,
                        email: event.target.value,
                      });
                    }}
                    // required={true}
                    disabled={isEdite ? false : true}
                    loading={loadingDerler}
                  />
                </div>
                <div className={styles.nm_info}>
                  <InputTag
                    labelText={"WhatsApp Number"}
                    star={true}
                    padding={"8px"}
                    fontSize={"12px"}
                    placeholderText={"Enter WhatsApp Number"}
                    maxLength={10}
                    placeholderType={"number"}
                    value={genralInfo?.whatsapp}
                    onChange={(event) => {
                      setGenralInfo({
                        ...genralInfo,
                        whatsapp: event.target.value,
                      });
                    }}
                    required={true}
                    disabled={isEdite ? false : true}
                    loading={loadingDerler}
                  />
                </div>
                <div className={styles.nm_info}>
                  <InputTag
                    labelText={"GSTUIN(Optional)"}
                    // star={true}
                    padding={"8px"}
                    fontSize={"12px"}
                    placeholderText={"Enter GSTUIN"}
                    maxLength={100}
                    placeholderType={"text"}
                    value={genralInfo?.gstuin}
                    onChange={(event) => {
                      setGenralInfo({
                        ...genralInfo,
                        gstuin: event.target.value,
                      });
                    }}
                    disabled={isEdite ? false : true}
                    loading={loadingDerler}
                  />
                </div>
              </div>
              <div className={styles.Company_SeacandChile}>
                <p> Upload Your Documents </p>
                <UploadSingleFile text={"Aadhar Card"} />
                <div style={{ marginTop: "10px" }}>
                  <UploadSingleFile text={"Pan card"} />
                </div>
              </div>
            </div>
          </div>
          {/* map Address  */}
          <div className={styles.Location}>
            <div
              className={styles.LocationAdress}
              style={{
                backgroundColor: mode ? "#232529" : "#fff",
                color: mode ? "#fff" : "#000",
              }}
            >
              <p>Location</p>
              <div className={styles.nm_info}>
                <InputTag
                  labelText={"Street Address"}
                  star={true}
                  padding={"8px"}
                  fontSize={"12px"}
                  placeholderText={"Enter Street"}
                  maxLength={50}
                  placeholderType={"text"}
                  value={genralInfo?.street}
                  onChange={(event) => {
                    setGenralInfo({
                      ...genralInfo,
                      street: event.target.value,
                    });
                  }}
                  required={true}
                  disabled={isEdite ? false : true}
                  loading={loadingDerler}
                />
              </div>
              <div className={styles.nm_info}>
                <InputTag
                  labelText={"PIN Code"}
                  star={true}
                  padding={"8px"}
                  fontSize={"12px"}
                  placeholderText={"Enter PIN Code"}
                  maxLength={6}
                  placeholderType={"number"}
                  value={genralInfo?.pincode}
                  onChange={(event) => {
                    setGenralInfo({
                      ...genralInfo,
                      pincode: event.target.value,
                    });
                  }}
                  required={true}
                  disabled={isEdite ? false : true}
                  loading={loadingDerler}
                />
              </div>
              <div className={styles.nm_info}>
                <InputTag
                  labelText={"District"}
                  star={true}
                  padding={"8px"}
                  fontSize={"12px"}
                  placeholderText={"Enter District"}
                  maxLength={50}
                  placeholderType={"text"}
                  value={genralInfo?.district}
                  loading={loading.locationLoading}
                  onChange={(event) => {
                    setGenralInfo({
                      ...genralInfo,
                      district: event.target.value,
                    });
                  }}
                  required={true}
                  // disabled={isEdite ? false : true}
                  disabled={true}
                />
              </div>
              <div className={styles.nm_info}>
                <InputTag
                  labelText={"City"}
                  star={true}
                  padding={"8px"}
                  fontSize={"12px"}
                  placeholderText={"Enter City"}
                  maxLength={50}
                  placeholderType={"text"}
                  value={genralInfo?.city}
                  loading={loading.locationLoading}
                  onChange={(event) => {
                    setGenralInfo({ ...genralInfo, city: event.target.value });
                  }}
                  required={true}
                  // disabled={isEdite ? false : true}
                  disabled={true}
                />
              </div>
              <div className={styles.nm_info}>
                <InputTag
                  labelText={"State"}
                  star={true}
                  padding={"8px"}
                  fontSize={"12px"}
                  placeholderText={"Enter State"}
                  maxLength={50}
                  placeholderType={"text"}
                  value={genralInfo?.state}
                  loading={loading.locationLoading}
                  onChange={(event) => {
                    setGenralInfo({ ...genralInfo, state: event.target.value });
                  }}
                  required={true}
                  // disabled={isEdite ? false : true} 
                  disabled={true}
                />
              </div>
              <div className={styles.nm_info}>
                <InputTag
                  labelText={"Country"}
                  star={true}
                  padding={"8px"}
                  fontSize={"12px"}
                  placeholderText={"Enter Country"}
                  maxLength={50}
                  placeholderType={"text"}
                  value={genralInfo?.country}
                  onChange={(event) => {
                    setGenralInfo({
                      ...genralInfo,
                      country: event.target.value,
                    });
                  }}
                  required={true}
                  disabled={true}
                />
              </div>
            </div>
            <div
              className={styles.LocationMap}
              style={{
                backgroundColor: mode ? "#232529" : "#fff",
                color: mode ? "#fff" : "#000",
              }}
            >
              <div className={styles.nm_info}>
                <span style={{ fontSize: "14px" }}>
                  {" "}
                  Google map (Optional){" "}
                </span>
                <input
                  ref={searchInput}
                  type="search"
                  placeholder="Search place"
                  className={styles.seacrh_inputField1}
                  value={inputSearch}
                  disabled={isEdite ? false : true}
                  onChange={(e) => {
                    setInputSearch(e.target.value);
                  }}
                  style={{
                    backgroundColor: mode ? "#1B1D21" : "#FFFFFF",
                    border: mode ? "none" : "1px solid #D9D9D9",
                    color: mode ? "#FFFFFF" : "#000",
                  }}
                />
              </div>

              <div className={styles.Location_map}>
                {address?.place_id && (
                  <iframe
                    className={styles.google_map}
                    loading="lazy"
                    allowFullScreen
                    style={{ backgroundColor: mode ? "#000" : "#fff" }}
                    title="Wallicon Private Limited"
                    src={`https://www.google.com/maps/embed/v1/place?q=place_id:${address?.place_id}&key=${process.env.REACT_APP_MAP_KEY}`}
                  />
                )}
              </div>
            </div>
            <div
              className={styles.Account_Setting}
              style={{
                backgroundColor: mode ? "#232529" : "#fff",
                color: mode ? "#fff" : "#000",
              }}
            >
              <p>Account Setting</p>
              <div className={styles.nm_info}>
                <VerticalDropDown
                  dropDownText={"Sales 4"}
                  label={"Assign Order Manager"}
                  height={"37px"}
                  fontSize={"12px"}
                  value={{
                    label:
                      managers?.find(
                        (item) => item.managerId === genralInfo.managerId
                      )?.name || "Select",
                  }}
                  onchange={(option) => {
                    setGenralInfo({ ...genralInfo, managerId: option.value });
                  }}
                  options={managers?.map((item) => ({
                    label: item.name,
                    value: item.managerId,
                  }))}
                  star={true}
                  required={true}
                  disableOpen={isEdite ? false : true}
                />
              </div>
              <div className={styles.nm_info}>
                <VerticalDropDown
                  dropDownText={"Sales 4"}
                  label={"Status"}
                  height={"37px"}
                  fontSize={"12px"}
                  value={genralInfo.status ? { label: genralInfo.status } : { label: "Select" }}
                  onchange={(option) => {
                    setGenralInfo({ ...genralInfo, status: option.value });
                  }}
                  options={[
                    {label: "New", value: "New"},
                    {label: "Pending", value: "Pending"},
                    {label: "Verified", value: "Verified"},
                    {label: "Update", value: "Update"},
                    {label: "Blacklisted", value: "Blacklisted"},
                    {label: "Rejected", value: "Rejected"},
                    {label: "Deleted", value: "Deleted"},
                  ]}
                  star={true}
                  required={true}
                  disableOpen={isEdite ? false : true}
                />
              </div>



              <div className={styles.redioBtnConintner}>
                <div
                  className={styles.redioText}
                  style={{ color: mode ? "#FFFFFF" : "#646B88" }}
                >
                  Organic leads{" "}
                </div>
                <div className={styles.redioBtnConintner2}>
                  <InputRedio
                    lableText="Active"
                    name="Organic"
                    checked={genralInfo?.catalogStatus === "Active"}
                    onChange={() =>
                      setGenralInfo({ ...genralInfo, catalogStatus: "Active" })
                    }
                    required={true}
                    disabled={isEdite ? false : true}
                  />
                  <InputRedio
                    lableText="Disable"
                    name="Organic"
                    // value="Disable"
                    checked={genralInfo?.catalogStatus === "Disable"}
                    onChange={() =>
                      setGenralInfo({ ...genralInfo, catalogStatus: "Disable" })
                    }
                    required={true}
                    disabled={isEdite ? false : true}
                  />
                </div>
              </div>
              <div className={styles.redioBtnConintner}>
                <div
                  className={styles.redioText}
                  style={{ color: mode ? "#FFFFFF" : "#646B88" }}
                >
                  Shipping Block Services{" "}
                </div>
                <div className={styles.redioBtnConintner2}>
                  <InputRedio
                    lableText="Active"
                    name="shippingBlock"
                    checked={genralInfo?.shippingBlock === true}
                    onChange={() =>
                      setGenralInfo({ ...genralInfo, shippingBlock: true })
                    }
                    required={true}
                    disabled={isEdite ? false : true}
                  />
                  <InputRedio
                    lableText="Disable"
                    name="shippingBlock"
                    // value="Disable"
                    checked={genralInfo?.shippingBlock === false}
                    onChange={() =>
                      setGenralInfo({ ...genralInfo, shippingBlock: false })
                    }
                    required={true}
                    disabled={isEdite ? false : true}
                  />
                </div>
              </div>

              <div className={styles.redioBtnConintner}>
                <div
                  className={styles.redioText}
                  style={{ color: mode ? "#FFFFFF" : "#646B88" }}
                >
                  POD (Pay On Delivery){" "}
                </div>
                <div className={styles.redioBtnConintner2}>
                  <InputRedio
                    lableText="Active"
                    name="pod"
                    checked={genralInfo?.pod === true}
                    onChange={() =>
                      setGenralInfo({ ...genralInfo, pod: true })
                    }
                    required={true}
                    disabled={isEdite ? false : true}
                  />
                  <InputRedio
                    lableText="Disable"
                    name="pod"
                    // value="Disable"
                    checked={genralInfo?.pod === false}
                    onChange={() =>
                      setGenralInfo({ ...genralInfo, pod: false })
                    }
                    required={true}
                    disabled={isEdite ? false : true}
                  />
                </div>
              </div>

              {
                genralInfo.pod === false &&
                <div
                  className={styles.req_for_cancel}
                  style={mode ? { backgroundColor: "#232529" } : {}}
                >
                  <p style={mode ? { color: "#FFFFFF", margin: 0 } : {}}
                    className={styles.req_for_cancel_text}
                  > POD Block Reason </p>
                  <textarea
                    // name=""
                    // id=""
                    placeholder="*Type your Reason here"
                    required
                    rows="4"
                    disabled={isEdite ? false : true}
                    value={genralInfo.podReason}
                    onChange={(event) => {
                      setGenralInfo({ ...genralInfo, podReason: event.target.value });
                    }}
                    // onChange={(e) => setReason(e.target.value)}
                    className={`${styles.textarea} ${mode ? styles.textarea_dark : ""}`}
                  ></textarea>
                </div>
              }
              <div className={styles.redioBtnConintner}>
                <div
                  className={styles.redioText}
                  style={{ color: mode ? "#FFFFFF" : "#646B88" }}
                >
                  No Return No Exchange Mandotory Checkbox
                </div>
                <div className={styles.redioBtnConintner2}>
                  <InputRedio
                    lableText="Active"
                    name="Mandotory"
                    checked={genralInfo?.nrne === "Active"}
                    onChange={() =>
                      setGenralInfo({ ...genralInfo, nrne: "Active" })
                    }
                    required={true}
                    disabled={isEdite ? false : true}
                  />

                  <InputRedio
                    lableText="Disable"
                    name="Mandotory"
                    checked={genralInfo?.nrne === "Disable"}
                    onChange={() =>
                      setGenralInfo({ ...genralInfo, nrne: "Disable" })
                    }
                    required={true}
                    disabled={isEdite ? false : true}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className={styles.sosal_Media}>
            <div
              className={styles.sosale_media_link}
              style={{
                backgroundColor: mode ? "#232529" : "#fff",
                color: mode ? "#fff" : "#000",
              }}
            >
              <div className={styles.nm_info}>
                <VerticalDropDown
                  dropDownText={"Enter your Exp"}
                  label={"Experience"}
                  height={"37px"}
                  fontSize={"12px"}
                  value={{
                    label:
                      {
                        1: "1 Year +",
                        2: "2 Year +",
                        3: "3 Year +",
                        4: "4 Year +",
                        5: "5 Year +",
                      }[genralInfo.experience] || "Select",
                  }}
                  onchange={(option) => {
                    setGenralInfo({ ...genralInfo, experience: option.value });
                  }}
                  options={[
                    { label: "1 Year +", value: 1 },
                    { label: "2 Year +", value: 2 },
                    { label: "3 Year +", value: 3 },
                    { label: "4 Year +", value: 4 },
                    { label: "5 Year +", value: 5 },
                  ]}
                  star={true}
                  disabled={isEdite ? false : true}
                />
              </div>
              <div className={styles.nm_info}>
                <InputTag
                  labelText={"Facebook"}
                  // star={true}
                  padding={"8px"}
                  fontSize={"12px"}
                  placeholderText={"www.facebook.com"}
                  maxLength={100}
                  placeholderType={"text"}
                  value={genralInfo?.facebook}
                  onChange={(event) => {
                    setGenralInfo({
                      ...genralInfo,
                      facebook: event.target.value,
                    });
                  }}
                  disabled={isEdite ? false : true}
                />
              </div>
              <div className={styles.nm_info}>
                <InputTag
                  labelText={"Instagram"}
                  // star={true}
                  padding={"8px"}
                  fontSize={"12px"}
                  placeholderText={"www.instagram.com"}
                  maxLength={100}
                  placeholderType={"text"}
                  value={genralInfo?.instagram}
                  onChange={(event) => {
                    setGenralInfo({
                      ...genralInfo,
                      instagram: event.target.value,
                    });
                  }}
                  disabled={isEdite ? false : true}
                />
              </div>
              <div className={styles.nm_info}>
                <InputTag
                  labelText={"YouTube"}
                  // star={true}
                  padding={"8px"}
                  fontSize={"12px"}
                  placeholderText={"www.youbute.com"}
                  maxLength={100}
                  placeholderType={"text"}
                  value={genralInfo?.youtube}
                  onChange={(event) => {
                    setGenralInfo({
                      ...genralInfo,
                      youtube: event.target.value,
                    });
                  }}
                  disabled={isEdite ? false : true}
                />
              </div>
              <div className={styles.nm_info}>
                <InputTag
                  labelText={"Twitter"}
                  // star={true}
                  padding={"8px"}
                  fontSize={"12px"}
                  placeholderText={"www.twitter.com"}
                  maxLength={100}
                  placeholderType={"text"}
                  value={genralInfo?.twitter}
                  onChange={(event) => {
                    setGenralInfo({
                      ...genralInfo,
                      twitter: event.target.value,
                    });
                  }}
                  disabled={isEdite ? false : true}
                />
              </div>
              <div className={styles.nm_info}>
                <InputTag
                  labelText={"Pinterest"}
                  // star={true}
                  padding={"8px"}
                  fontSize={"12px"}
                  placeholderText={"www.pinterest.com"}
                  maxLength={100}
                  placeholderType={"text"}
                  value={genralInfo?.pinterest}
                  onChange={(event) => {
                    setGenralInfo({
                      ...genralInfo,
                      pinterest: event.target.value,
                    });
                  }}
                  disabled={isEdite ? false : true}
                />
              </div>
            </div>
            <div
              className={styles.sosale_media_About}
              style={{
                backgroundColor: mode ? "#232529" : "#fff",
                color: mode ? "#fff" : "#000",
              }}
            >
              <p>Product they want to sell</p>
              <div className={styles.KycChack_coontiner}>
                {allProducts.map((product) => {
                  const isSelected = selectedProducts.some(
                    (item) => item.product_id === product.product_id
                  );

                  return (
                    <div
                      className={styles.kycchack}
                      style={{
                        backgroundColor: mode ? "#2C2E33" : "#F8F9FC",
                        color: isSelected
                          ? "green"
                          : mode
                            ? "#FFFFFF"
                            : "#4164E3",
                      }}
                      key={product?.product_id}
                      onClick={() => {
                        if (isEdite) {
                          if (isSelected) {
                            setSelectedProducts(selectedProducts.filter((item) => item.product_id !== product.product_id));
                          } else {
                            setSelectedProducts([...selectedProducts, product]);
                          }
                        }
                      }}

                    >
                      {isSelected ? (
                        <KycPls mode={mode} isSelect={isSelected} />
                      ) : (
                        <KycPls mode={mode} />
                      )}
                      {product?.product_name}
                    </div>
                  );
                })}
              </div>
              <div
                className={styles.KycChack_coontiner1}
                style={{ marginTop: "10px" }}
              >
                <div style={{ marginBottom: "10px" }}> Description</div>
                <div>
                  <textarea
                    className={styles.Description_textarea}
                    style={{
                      backgroundColor: mode ? "#1D1F23" : "#FCFDFE",
                      color: mode ? "#FFFFFF" : "#000",
                      border: mode ? "1px solid #1D1F23" : "1px solid #D9D9D9",
                      minHeight: "200px",
                    }}
                    value={genralInfo?.storeDesc}
                    disabled={isEdite ? false : true}
                    placeholder="Enter description"
                    onChange={(event) => {
                      setGenralInfo({
                        ...genralInfo,
                        storeDesc: event.target.value,
                      });
                    }}
                  ></textarea>
                </div>
                <div className={styles.textarea_text}>
                  <div>
                    First 50-160 letters will be used for your Search Engine
                    ranking.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className={styles.upload_file}
            style={{
              backgroundColor: mode ? "#232529" : "#fff",
              color: mode ? "#fff" : "#000",
            }}
          >
            <p>Store Image</p>
            <div className={styles.upload_file_continer}>
              {StoreImage !== "" ? (
                <div className={styles.imagePreview1}>
                  <img
                    src={
                      StoreImage instanceof File
                        ? URL.createObjectURL(StoreImage)
                        : StoreImage
                    }
                    alt="Preview"
                    className={styles.uploadedImage1}
                  />
                  <div className={styles.removeIcon} onClick={() => isEdite ? setStoreImage('') : null}>
                    <Delete1 />
                  </div>
                </div>
              ) : (
                <>
                  <div>
                    <KycUplodFile />
                  </div>
                  <div>
                    <p style={{ margin: "0" }}>
                      {" "}
                      <span
                        className={styles.browseSpan}
                        onClick={isEdite ? handlePhotoUploadClick1 : null}
                      >
                        {" "}
                        Click to upload{" "}
                      </span>{" "}
                      or drag and drop
                    </p>
                  </div>
                  <div>
                  </div>
                  <input
                    type="file"
                    id="fileInput"
                    accept="image/*"
                    style={{ display: "none" }}
                    ref={inputForstore}
                    onChange={handleChangeForStoreImage}
                  />
                </>
              )}


            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default Kyc;
